import Collapse from '@mui/material/Collapse';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

interface QuoteSubmissionProgressProps {
  progressPercentage: number;
  show: boolean;
}

/**
 * Progress indicator component for quote submission.
 * Displays a progress bar and percentage text.
 */
export const QuoteSubmissionProgress = ({
  progressPercentage,
  show,
}: QuoteSubmissionProgressProps) => {
  return (
    <Collapse in={show}>
      <ProgressContainer>
        <ProgressBar variant='determinate' value={progressPercentage} />
        <ProgressText variant='body2'>
          Submission Progress: {Math.round(progressPercentage)}%
        </ProgressText>
      </ProgressContainer>
    </Collapse>
  );
};

const ProgressContainer = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(1),
}));

const ProgressBar = styled(LinearProgress)(({ theme }) => ({
  marginBottom: theme.spacing(1),
}));

const ProgressText = styled(Typography)({
  textAlign: 'center',
  fontWeight: 500,
});
